import {action, makeAutoObservable} from "mobx"
import {RootStore} from "../index";
import ClientModel from "../../model/ClientModel";

export class PageCommercialStore {
    private rootStore: RootStore | undefined;
    arElement = {}
    prizes = [];
    discountsByProducer = [];
    contracts = [];

    hash = '';
    clientId: number | undefined = 0;
    selectedOption = null;
    options = [];
    value = 20;
    aaa = 0
    randomNumber: number = 1;
    valueSlider = 0;
    indexAdded = 0;



    public error: string = '';

    constructor(rootStore?: RootStore) {
        makeAutoObservable(this);
        this.rootStore = rootStore;
    }

    init(hash: string, code: string) {
        this.hash = hash;
        this.clientId = code ? parseInt(code) : this.rootStore?.mainStore.getClientId();
        ClientModel.getClient(this.clientId, this.setElement, this.setError);
        ClientModel.getClients(this.setClients, this.setError);
    }



    @action
    setElement = (result: any) => {
        this.arElement = result.data;

        this.prizes=[];
        this.discountsByProducer= result.data.discountsByProducer;
        this.contracts=result.data.contracts
        // @ts-ignore
        if (this.arElement.tradePrizes !== null && this.arElement.tradePrizes !== undefined) {
            let indexs: any[] = [];
            let i = 0;
            // @ts-ignore
            this.arElement.tradePrizes.map((ev: any) => {
                i = indexs.indexOf(ev.producername);
                if (i > -1) {
                    // @ts-ignore
                    this.prizes[i]['totalstradeprize']?.push(ev.totaltradeprize)
                } else {
                    indexs.push(ev.producername);
                    ev['totalstradeprize'] = [ev.totaltradeprize];
                    // @ts-ignore
                    this.prizes.push(ev);
                    this.prizes.sort(function(a,b) {
                        // @ts-ignore
                        let x = a.producername.toLowerCase();
                        // @ts-ignore
                        let y = b.producername.toLowerCase();
                        return x < y ? -1 : x > y ? 1 : 0;
                    });

                }
            });
        }





    }

    @action
    detectsXPosition = (event: any, newValue: number ) => {

        let limit = event.pageY
        if (event.pageY < 565){
            limit = 565
        }
        if (event.pageY > 862){
            limit = 862
        }
        this.valueSlider = (565 - limit)*(-1)/2.5  ;
        this.aaa = this.valueSlider * 58 / 6;

        this.indexAdded = this.valueSlider / 2

    }
    @action
    detectsXPositionHorizontal = (event: any, newValue: number ) => {
        this.valueSlider = newValue ;
        this.aaa = this.valueSlider * 116 / 6;
        this.indexAdded = Math.round(this.valueSlider * 3 / 6)

    }


    @action
    position = (e: any, Width: any) => {
        if (Width > 760 ){
            // this.valueSlider = e.target.scrollTop  / 58 * 6

            this.aaa = e.target.scrollTop
            this.valueSlider = this.aaa / 58 * 6
        } else {
            // this.valueSlider = e.target.scrollTop / 27

            this.aaa = e.target.scrollTop
            this.valueSlider = this.aaa / 27
        }

    }

    unique(arr: any) {
        let result: any[] = [];

        for (let str of arr) {
            if (!result.includes(str)) {
                result.push(str);
            }
        }

        return result;
    }


    @action
    setClients = (result: any) => {
        this.options = [];

        if (result.data?.length) {

            let selected={
                value: result.data[0]?.id,
                label: result.data[0].name,
            }

            result.data.map((item: any) => {
                if(item?.id===this.clientId){
                    selected={
                        value: item?.id,
                        label: item?.name,
                    }
                }
                this.options.push({
                    // @ts-ignore
                    value: item?.id,
                    // @ts-ignore
                    label: item?.name,
                });
                return item;
            });

            // @ts-ignore
            this.selectedOption = selected;
        }
    }

    @action setSelectedOption = (e: any) => {
        this.selectedOption = e;
        // @ts-ignore
        ClientModel.getClient(this.selectedOption?.value, this.setElement, this.setError);
    }

    @action
    setError = (error: any) => {
        console.log(error);
    }

    @action
    setHash = (hash: string) => {
        this.hash = hash;
    }
}
